import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  providerId: string().required(),
  visitType: string().required(),
})

export const url = ({ providerId, visitType }) => `v1/providers/${providerId}/questionnaire/latest/${visitType}`
